// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class Document {
    static getAttributeTypeMap() {
        return Document.attributeTypeMap;
    }
}
Document.discriminator = undefined;
Document.additionalProperties = false;
Document.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "applyAnchorTabs",
        "baseName": "applyAnchorTabs",
        "type": "boolean"
    },
    {
        "name": "transformPdfFields",
        "baseName": "transformPdfFields",
        "type": "boolean"
    },
    {
        "name": "documentBase64",
        "baseName": "documentBase64",
        "type": "string"
    },
    {
        "name": "checkboxTabs",
        "baseName": "checkboxTabs",
        "type": ""
    },
    {
        "name": "dateSignedTabs",
        "baseName": "dateSignedTabs",
        "type": ""
    },
    {
        "name": "initialHereTabs",
        "baseName": "initialHereTabs",
        "type": ""
    },
    {
        "name": "listTabs",
        "baseName": "listTabs",
        "type": ""
    },
    {
        "name": "radioGroupTabs",
        "baseName": "radioGroupTabs",
        "type": ""
    },
    {
        "name": "signHereTabs",
        "baseName": "signHereTabs",
        "type": ""
    },
    {
        "name": "textTabs",
        "baseName": "textTabs",
        "type": ""
    },
];
//# sourceMappingURL=document.js.map